<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Service-Konfiguration</h4>
        </div>
    </div>

    <div class="row" [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                    (keydown)="onKeydown($event)">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Rolle</mat-label>
                <mat-select formControlName="filterByRoles" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByRoles.value != null ">
                            {{this.filterForm.controls.filterByRoles.value | translateFilterServices : 'filterByRoles'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByRoles.value?.length > 1">
                            (+{{this.filterForm.controls.filterByRoles.value.length - 1 }}
                            {{this.filterForm.controls.filterByRoles.value?.length === 2 ? 'anderer' :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of roleOptions" [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>

            </mat-form-field>
        </div>


        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select formControlName="filterByStates" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByStates.value != null ">
                            {{this.filterForm.controls.filterByStates.value | translateFilterServices :
                            'filterByStates'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByStates.value?.length > 1">
                            (+{{this.filterForm.controls.filterByStates.value.length - 1 }}
                            {{this.filterForm.controls.filterByStates.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of stateOptions" [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>

            </mat-form-field>
        </div>


        <!-- <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Baustein</mat-label>
                <mat-select formControlName="filterByModules" multiple="true">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByModules.value != null ">
                            {{this.filterForm.controls.filterByModules.value | translateFilterServices : 'filterByModules'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByModules.value?.length > 1"
                            >
                            (+{{this.filterForm.controls.filterByModules.value.length - 1 }}
                            {{this.filterForm.controls.filterByModules.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of moduleOptions" [value]="sortOption.value">
                        {{sortOption.viewValue}}</mat-option>
                </mat-select>

            </mat-form-field>
        </div> -->
    </div>

    <div class="row marginBottom2Rem">
        <div class="col-sm-12 ">
            <button mat-button mat-raised-button color="accent" (click)="filterServices()">
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFitler()" style="margin-left: 15px;">
                Filter zurücksetzen
            </button>
        </div>
    </div>


    <div class="row marginBottom2Rem">
        <div class="col-sm-12">
            <div class="actionRow mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="active">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktiv
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <mat-checkbox [(ngModel)]="element.active" (change)="updateContractStatus(element)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            Name
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.name}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="path">
                        <th mat-header-cell *matHeaderCellDef>
                            Pfad
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.path}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="permission">
                        <th mat-header-cell *matHeaderCellDef>
                            Verfügbar für
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.permission | permissionDisplayName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef>
                            Wert
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;" class="mat-column">
                            <mat-form-field *ngIf="element.hasValue" appearance="fill" style="width: 250px;">
                                <mat-label>Wert</mat-label>
                                <input matInput [(ngModel)]="element.value" (input)="serviceHasChanged[i] = true;">
                            </mat-form-field>


                            <div *ngIf="!element.hasValue">
                                <p style="height: 50px;display: flex;align-items: center;"></p>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element;let i = index;" class="mat-column">

                            <button mat-raised-button color="primary" (click)="updateContract(element)" fxFlex="40%"
                                *ngIf="serviceHasChanged[i]">
                                Speichern
                            </button>

                            <div  *ngIf="!serviceHasChanged[i]" style="width: 100px;"></div>
                        </td>
                    </ng-container>


                    

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine
                    passenden
                    Einträge
                    gefunden...</span>
            </div>
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>